import axios from '../assets/axios.wrap';
const contextPath = '/remote';
export function getStatList(data) {
    return axios.get(`${contextPath}/dict/list`, { params: data });
}
export function setFault(data) {
    return axios.postByFormData(`${contextPath}/monitor/setfault`, data);
}
